/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1TutoraiDocumentsClassstudentidMutationRequest,
  PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
  PostApiV1TutoraiDocumentsClassstudentidPathParams,
  PostApiV1TutoraiDocumentsClassstudentid400,
  PostApiV1TutoraiDocumentsClassstudentid401,
  PostApiV1TutoraiDocumentsClassstudentid500,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsClassstudentid.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1TutoraiDocumentsClassstudentidUrl(
  classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/tutorai/documents/${classStudentId}` as const,
  };
  return res;
}

/**
 * @description Envia o arquivo para o TutorAI e cria o registro com status `Pending`. Formatos aceitos: PDF, MD, TXT. **(Requer Authorization para autenticação)**
 * @summary Upload de documento (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:classStudentId}
 */
export async function postApiV1TutoraiDocumentsClassstudentid(
  classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"],
  data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1TutoraiDocumentsClassstudentidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsClassstudentid400
      | PostApiV1TutoraiDocumentsClassstudentid401
      | PostApiV1TutoraiDocumentsClassstudentid500
    >,
    PostApiV1TutoraiDocumentsClassstudentidMutationRequest
  >({
    method: "POST",
    url: getPostApiV1TutoraiDocumentsClassstudentidUrl(
      classStudentId,
    ).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
